import { render, staticRenderFns } from "./CourseOutcomes.vue?vue&type=template&id=12d511eb&scoped=true&"
import script from "./CourseOutcomes.vue?vue&type=script&lang=js&"
export * from "./CourseOutcomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d511eb",
  null
  
)

export default component.exports